document.addEventListener('DOMContentLoaded', function () {
  var filterToggle = document.querySelector('.filter-toggle');
  var filtersPanel = document.getElementById('collection-filters');
  var closeBtn = document.querySelector('.facets-close');

  function openFilters() {
    filtersPanel.classList.add('is-open');
    filterToggle.setAttribute('aria-expanded', 'true');
  }
  function closeFilters() {
    filtersPanel.classList.remove('is-open');
    filterToggle.setAttribute('aria-expanded', 'false');
  }

  if (filterToggle) {
    filterToggle.addEventListener('click', function () {
      var isOpen = filtersPanel.classList.contains('is-open');
      isOpen ? closeFilters() : openFilters();
    });
  }
  if (closeBtn) {
    closeBtn.addEventListener('click', closeFilters);
  }

  // Facet checkboxes auto-submit on change (native Shopify filtering)
  var facetForm = document.getElementById('FacetFilterForm');
  if (facetForm) {
    facetForm.querySelectorAll('input[type="checkbox"], input[type="number"]').forEach(function (input) {
      input.addEventListener('change', function () {
        submitFilters();
      });
    });
  }

  function submitFilters() {
    var formData = new FormData(facetForm);
    var params = new URLSearchParams();
    for (var pair of formData.entries()) {
      if (pair[1]) params.append(pair[0], pair[1]);
    }
    window.location.href = facetForm.dataset.collectionUrl + '?' + params.toString();
  }

  // Grid / List view toggle
  var viewButtons = document.querySelectorAll('.view-btn');
  var grid = document.querySelector('.product-grid');
  viewButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      viewButtons.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      if (grid) grid.setAttribute('data-grid-view', btn.dataset.view);
      if (btn.dataset.view === 'list') {
        grid.style.gridTemplateColumns = '1fr';
      } else {
        grid.style.gridTemplateColumns = '';
      }
    });
  });

  // Quick add to cart
  document.querySelectorAll('.product-card-quickadd').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          btn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        })
        .catch(function () {
          btn.textContent = 'Error';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        });
    });
  });
});

